import { Label } from "@/components/ui/label";
import { EVENT_STATUS, KIND } from "@/manager/lib";

export function PageHeader({ eyebrow, title, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && <p className="text-[10px] uppercase tracking-[0.3em] text-[#BBA77D] mb-2">{eyebrow}</p>}
        <h1 className="font-display text-3xl md:text-4xl text-[#101B28] tracking-tight">{title}</h1>
      </div>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export function StatCard({ label, value, tone = "default", onClick, testid }) {
  const tones = {
    default: "border-[#e6e1d6]", alert: "border-rose-300 bg-rose-50/60", warn: "border-amber-300 bg-amber-50/60",
  };
  return (
    <button onClick={onClick} data-testid={testid}
      className={`text-left bg-white border rounded-2xl px-5 py-4 hover:-translate-y-0.5 hover:shadow-md transition-[transform,box-shadow] ${tones[tone]}`}>
      <p className="font-display text-3xl text-[#101B28]">{value}</p>
      <p className="text-[11px] uppercase tracking-[0.16em] text-[#6b6a66] mt-1">{label}</p>
    </button>
  );
}

export const Pill = ({ className = "", children, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] border border-transparent whitespace-nowrap ${className}`}>{children}</span>
);

export const StatusPill = ({ status }) => <Pill className={EVENT_STATUS[status]?.cls}>{EVENT_STATUS[status]?.label || status}</Pill>;
export const KindPill = ({ kind }) => <Pill className={KIND[kind]?.cls}>{KIND[kind]?.label || kind}</Pill>;

export function Field({ label, children, className = "" }) {
  return (
    <div className={className}>
      <Label className="text-[11px] uppercase tracking-[0.14em] text-[#6b6a66]">{label}</Label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export const Card = ({ className = "", children, ...rest }) => (
  <div className={`bg-white border border-[#e6e1d6] rounded-2xl ${className}`} {...rest}>{children}</div>
);

export const Empty = ({ children }) => <p className="text-sm text-[#6b6a66] py-8 text-center">{children}</p>;

export const goldBtn = "rounded-full bg-[#101B28] hover:bg-[#1d2c3f] text-[#F7F5F0] gap-2";
